import React from 'react';
import { Card } from 'react-bootstrap';
import './orbs-card-component.scss';
import { useNavigate } from 'react-router-dom';
import LazyCardImageComponent from '../lazy-card-image/lazy-card-image-component';
import { Asset } from '../../models/asset-model';
import ShortTextControl from '../../controls/short-text/short-text-control';

type OrbsCardComponentProps = {
  item: Asset;
  defaultImagePath: string;
};

export default function OrbsCardComponent({ item, defaultImagePath }: OrbsCardComponentProps): JSX.Element {
  const navigate = useNavigate();

  const displayOrbDetailsPage = () => {
    navigate(`/orb/${item.assetId}`);
  };

  return (
    <Card className="cards orbs-card-component">
      <LazyCardImageComponent assetParam={item} defaultImagePath={defaultImagePath} />
      <Card.Body onClick={displayOrbDetailsPage}>
        <h5>
          <ShortTextControl text={item?.contracts[0].address} numberOfChars={11} justifyBetween />
        </h5>
        <h6>{item.contracts[0].blockchain}</h6>
      </Card.Body>
    </Card>
  );
}
